import { z } from "zod";

export const getOrganizationAttendancesQuerySchema = z.object({
	startDate: z.string().optional(),
	endDate: z.string().optional(),
	teamId: z.uuid().optional(),
	state: z.enum(["pending", "approved", "rejected"]).optional(),
});

export type GetOrganizationAttendancesQuerySchema = z.infer<
	typeof getOrganizationAttendancesQuerySchema
>;
